import { ChangeDetectionStrategy, Component, HostBinding } from "@angular/core";

@Component({
    selector: "sps-page-title",
    templateUrl: "./sps-page-title.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpsPageTitleComponent {
    static readonly displayName = "sps-page-title";
    static readonly props = {};

    @HostBinding("class.sps-page-title") readonly _spsPageTitleClass = true;
}
